import { ReactElement } from 'react'
import { BackButton } from '../../../../components'
import { useHistory } from 'react-router-dom'
import { UserLogo, Details, ColumnWrapper, CardWrapper } from '../subcomponents'
import FigureImage from 'react-bootstrap/esm/FigureImage'
import userLogo from '../../../../assets/user.png'
import { FlexWrapper, Column, PageWrapper } from '../../../../components'
import strings from '../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { Admin } from '../../../../redux/coachingCenter/types'
import { selectAdmin } from '../../../../redux/coachingCenter/actions'

const UserDetail = (): ReactElement => {
  const { admin } = useSelector(
    (state: RootState) => ({
      admin: state.coachingCenter.selectedAdmin as Admin
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    userDetail: {
      fatherName,
      userName,
      userType,
      salutation,
      lastName,
      firstName,
      qualification,
      mobileNumber,
      email,
      dob,
      address1,
      address2,
      country,
      state,
      city,
      zipcode,
      status
    }
  } = strings

  return (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(selectAdmin(null))
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper>
        <UserLogo>
          <FigureImage width={140} height={150} alt="171x180" src={userLogo} />
        </UserLogo>
        <Details>
          <ColumnWrapper>
            <Column keyName={userType} value={admin?.userType || ''} />
            <Column keyName={salutation} value={admin?.salutation || ''} />
            <Column keyName={lastName} value={admin?.lastName || ''} />
          </ColumnWrapper>
          <ColumnWrapper>
            <Column keyName={userName} value={admin?.user?.userName || ''} />
            <Column keyName={firstName} value={admin?.firstName || ''} />
          </ColumnWrapper>
        </Details>
      </FlexWrapper>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={fatherName} value={admin?.fatherName || ''} />
          <Column keyName={qualification} value={admin?.qualification || ''} />
          <Column keyName={mobileNumber} value={admin?.mobileNumber || ''} />
          <Column keyName={email} value={admin?.email || ''} />
          <Column keyName={dob} value={admin?.dob || ''} />
          <Column keyName={address1} value={admin?.address1 || ''} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={address2} value={admin?.address2 || ''} />
          <Column keyName={country} value={admin?.country || ''} />
          <Column keyName={state} value={admin?.state || ''} />
          <Column keyName={city} value={admin?.city || ''} />
          <Column keyName={zipcode} value={admin?.zipCode || ''} />
          <Column keyName={status} value={admin?.status || ''} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default UserDetail
